module.exports = __webpack_public_path__ + "assets/img/ContractComparison-banner.bbcb10f5.png";